(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('stripeForm', ['$timeout', '$window', '$document', '$rootScope', function ($timeout, $window, $document, $rootScope) {
            return {
                restrict: 'E',
                scope: {
                    submit: '=',
                },
                templateUrl: '/templates/global/stripe-form.html?v=' + config.version,
                link: function (scope, element) {
                    let stripe;
                    let elements;
                    let cardNumberElement;
                    let stripeLoaded = false;

                    const form = element[0].querySelector('#stripe-payment-form');
                    const cardNameElement = element[0].querySelector('#stripe-card-name');
                    const cardNameErrorElement = element[0].querySelector('#stripe-name-error');
                    const cardNumErrorElement = element[0].querySelector('#stripe-cardNum-error');
                    const cardInfoErrorElement = element[0].querySelector('#stripe-info-error');
                    const stripeErrorElement = element[0].querySelector('#stripe-card-error');

                    const style = {
                        base: {
                            color: '#28292C',
                            fontFamily: 'Lato, sans-serif',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            '::placeholder': {
                                color: '#696A72',
                                fontStyle: 'italic',
                            },
                        },
                        invalid: {
                            fontFamily: 'Lato, sans-serif',
                            color: '#C8321A',
                        },
                    };

                    scope.$on('stripe-form-submit', ($event, termsValid) => {
                        scope.termsValid = termsValid;
                        scope.submitForm();
                    });

                    scope.init = () => {
                        scope.loadScript();
                        scope.loadElements();
                    };

                    scope.loadScript = function () {
                        if (stripeLoaded) {
                            return;
                        }

                        stripeLoaded = true;

                        const e = $document[0].createElement('script');
                        e.src = 'https://js.stripe.com/v3/';
                        $document[0].head.appendChild(e);
                    };

                    scope.loadElements = () => {
                        if (!$window.Stripe) {
                            $timeout(scope.loadElements, 100);
                            return;
                        }
                        stripe = $window.Stripe(config.stripe);
                        elements = stripe.elements();

                        cardNumberElement = elements.create('cardNumber', {
                            style: style,
                            placeholder: 'XXXX - XXXX - XXXX - XXXX',
                        });
                        cardNumberElement.mount('#stripe-card-number');

                        var cardExpiryElement = elements.create('cardExpiry', {
                            style: style,
                        });
                        cardExpiryElement.mount('#stripe-card-expiry');

                        var cardCvcElement = elements.create('cardCvc', {
                            style: style,
                        });
                        cardCvcElement.mount('#stripe-card-cvc');

                        var cardZipElement = elements.create('postalCode', {
                            style: style,
                            placeholder: 'Zip Code',
                        });
                        cardZipElement.mount('#stripe-card-zip');

                        cardNameElement.addEventListener('change', () => {
                            cardNameErrorElement.classList.remove('visible');
                            stripeErrorElement.classList.remove('visible');
                        });

                        cardNumberElement.on('change', function (event) {
                            cardNumErrorElement.classList.remove('visible');
                            stripeErrorElement.classList.remove('visible');

                            if (event.error) {
                                scope.displayError(event.error.message, cardNumErrorElement);
                            }
                        });

                        cardCvcElement.on('change', function (event) {
                            cardInfoErrorElement.classList.remove('visible');
                            stripeErrorElement.classList.remove('visible');

                            if (event.error) {
                                scope.displayError(event.error.message, cardInfoErrorElement);
                            }
                        });

                        cardExpiryElement.on('change', function (event) {
                            cardInfoErrorElement.classList.remove('visible');
                            stripeErrorElement.classList.remove('visible');

                            if (event.error) {
                                scope.displayError(event.error.message, cardInfoErrorElement);
                            }
                        });

                        cardZipElement.on('change', function (event) {
                            cardInfoErrorElement.classList.remove('visible');
                            stripeErrorElement.classList.remove('visible');

                            if (event.error) {
                                scope.displayError(event.error.message, cardInfoErrorElement);
                            }
                        });

                        form.addEventListener('submit', function (event) { // replace button with the real one
                            event.preventDefault();
                        });
                    };

                    scope.submitForm = () => {
                        const name = element[0].querySelector('#stripe-card-name').value;
                        let errors = false;

                        if (!name) {
                            scope.displayError('Your name is incomplete.', cardNameErrorElement);
                            errors = true;
                        }

                        if (!scope.termsValid) {
                            errors = true;
                            $window.scrollTo(0, $document[0].body.scrollHeight); // temporary fix for mobile to view error, need to rewrite stripe-form
                        }

                        if (errors) {
                            return;
                        }

                        var options = {
                            name: name,
                        };

                        stripe.createToken(cardNumberElement, options).then((result) => {
                            if (result.error) {
                                cardNumErrorElement.classList.remove('visible');
                                cardNameErrorElement.classList.remove('visible');
                                cardInfoErrorElement.classList.remove('visible');
                                scope.displayError(result.error.message, stripeErrorElement);
                                return;
                            }

                            scope.submit(result.token);
                        });
                    };

                    scope.displayError = (errorMessage, errorElement) => {
                        errorElement.textContent = '* ' + errorMessage;
                        errorElement.classList.add('visible');
                    };

                    $rootScope.resetStripeForm = function () {
                        cardNameElement.value = '';
                    };

                    scope.init();
                },
            };
        }]);
}());
